<template>
	<div>
		<div class="row">
			<div class="col">
				<!-- Show details -->
				<div>
					<!-- Contacts -->
					<section v-if="!editContact && hasContactPermissions && !isNewContact">
						<div class="row pt-4">
							<div class="col-sm-12 col-md-6 col-xl-4 pb-12">
								<a href="#" class="sau-bx-link" @click.prevent="addContact()">
									<div
										class="d-flex h-100 sau-bx bx-bdr-default bx-hvr-gray-dark bx-pad justify-content-center"
									>
										<div class="align-self-center text-center">
											<div style="height:100px" class="align-self-stretch">
												<i
													class="fal fa-plus-circle sau-bx-ico-group align-self-center pt-4"
													style="font-size:80px;"
													aria-hidden="true"
												></i>
											</div>
											<p>Add a contact</p>
										</div>
									</div>
								</a>
							</div>
							<div
								v-for="contact in contacts"
								:key="contact.id"
								class="col-sm-12 col-md-6 col-xl-4 pb-12 contact-container"
							>
								<!-- Navigate to 'Update Account' if contact id == userdetails.whmcs_contact_id -->
								<a href="/account/account-summary/edit" v-if="contact.id == userDetails.whmcs_contact_id">
									<div class="sau-bx text-center p-6 drop h-100">
										<img
											:src="contact.avatar"
											height="130"
											width="130"
											class="sau-avatar md bdr-gray md mx-auto my-2"
										>
										<h5 class="sau-font sau-para-m">{{contact.firstname}} {{contact.lastname}}</h5>
										<p class="sau-font sm sau-pm-reset">{{contact.phonenumber}}</p>
										<p class="sau-font xs sau-pm-reset break-word">{{contact.email}}</p>
									</div>
								</a>
								<a href="#" @click.prevent="editContact = contact" v-else>
									<div class="sau-bx text-center p-6 drop h-100">
										<img
											:src="contact.avatar"
											height="130"
											width="130"
											class="sau-avatar md bdr-gray md mx-auto my-2"
										>
										<h5 class="sau-font sau-para-m">{{contact.firstname}} {{contact.lastname}}</h5>
										<p class="sau-font sm sau-pm-reset">{{contact.phonenumber}}</p>
										<p class="sau-font xs sau-pm-reset break-word">{{contact.email}}</p>
									</div>
								</a>
							</div>
						</div>
					</section>
					<div class="row" v-if="!hasContactPermissions">
						<sau-request-permission></sau-request-permission>
					</div>
					<div v-if="editContact || isNewContact">
						<sau-account-contact-update :contact="editContact" v-on:change="contactEvent"></sau-account-contact-update>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			contacts: {},
			editContact: "",
			isNewContact: false,
			hasContactPermissions: false
		};
	},
	mounted() {
		this.hasContactPermissions = this.userDetails.whmcs_contact_id
			? this.userDetails.permissions.split(",").indexOf("contacts") > -1
			: true;

		if (this.hasContactPermissions) {
			this.startApp();
		}
	},
	methods: {
		startApp() {
			this.getContacts().then(response => {
				this.contacts = response.data;
			});
		},
		contactEvent(event) {
			switch (event.action) {
				case "delete":
					this.removeContact(event.id);
				default:
			}
		},
		addContact() {
			this.isNewContact = true;
		},
		removeContact(id) {
			var index = this.contacts
				.map(function(contact) {
					return contact.id;
				})
				.indexOf(id);
			this.contacts.splice(index, 1);
		}
	}
};
</script>
<style scss>
.contact-container a:hover,
.contact-container a:hover h5 {
	text-decoration: none;
	color: #666;
}

.contact-container a,
.contact-container h5 {
	color: #666;
}
.contact-container .sau-bx:hover {
	border: 1px solid #666;
}
.break-word {
	word-break: break-all;
}
</style>
